export default "__VITE_ASSET__yTkekeHq__"